// Trans.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Trans as I18nTrans } from 'react-i18next';

// Not sure why `Trans.components` can't handle nested component, so use `Wrapper` wrap component, ensuring that `Trans.components` will only have one level when used.
export const Trans = ({ components = [], ...rest }) => {
  return (
    <I18nTrans
      {...rest}
      components={components.map((c, i) => (
        <Wrapper key={i} render={() => c} />
      ))}
    />
  );
};

Trans.propTypes = {
  components: PropTypes.array,
};

const Wrapper = ({ render }) => {
  return render();
};

export default Trans;
